import { IsBoolean } from "class-validator";

export class AdminUpdateAccountResult {
    @IsBoolean()
    success: boolean;
}